import React, { useRef, 
	useEffect,
	//useState 
} from "react";
import { connect } from "react-redux";

import Print from "@arcgis/core/widgets/Print";
import { CalciteBlock } from "@esri/calcite-components-react";


const PrintMapBlock = ({isMapLoading, arcgisMap}) => {

	const printContainer = useRef(null);

	useEffect(() => {
		//console.log(arcgisMap, isMapLoading);
	  	if (printContainer.current && !printContainer.current.children.length && arcgisMap.map) {
			arcgisMap.when( () => {
				new Print({
					view: arcgisMap,
					printServiceUrl: `${process.env.REACT_APP_PRINT_SERVICE_URL || "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"}`,
					container: printContainer.current,
					allowedLayouts: [
					  "letter-ansi-a-landscape",
					  "letter-ansi-a-portrait",
					  "tabloid-ansi-b-landscape",
					  "tabloid-ansi-b-portrait",
					  // "a3-landscape",
					  // "a3-portrait",
					  // "a4-landscape",
					  // "a4-portrait",
					],
				  }
				  );
			});

		}
	}, [arcgisMap]);


	return (
		<CalciteBlock
		heading="Print Your Map"
		summary="Print your map into a format of your choice."
		collapsible={true}
		
		>
			<p><em>Note: Some basemaps may cause your print to fail.</em></p>
			<p><em>Note 2: Please do not add a space to the title.</em></p>
			<div ref={printContainer}></div>
		</CalciteBlock>
	);
}

const mapStateToProps = (state) => ({
	
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintMapBlock);
